import React from "react";
import { Input, Label, Alert, Hint } from "@americanexpress/dls-react";
import LabelTooltip from "./LabelTooltip";

/**
 * FormField is a reusable component that renders a labeled input field with optional tooltip, error message, and hint.
 *
 * Props:
 * - id: string (required) - The id for the input element.
 * - label: string (required) - The label text for the input.
 * - value: string (required) - The value of the input.
 * - onChange: function (required) - Handler for input change events.
 * - onBlur: function (optional) - Handler for input blur events.
 * - error: string (optional) - Error message to display below the input.
 * - colmd: string (optional) - CSS class for column layout (default: 'col-md-4').
 * - hint: string (optional) - Hint text to display below the input.
 * - tooltipText: string (optional) - Tooltip text to display next to the label.
 * - ...rest: any other props to pass to the Input component.
 */
const FormField = ({ id, label, value, onChange, onBlur, error, colmd = 'col-md-4', hint = '', tooltipText = '', toolTipModalComponent, ...rest }) => (
  <div className={`${colmd} col-xs-12 pad-2-b `} >
    {toolTipModalComponent ? (
      toolTipModalComponent
    ) : (
      <>
        <Label htmlFor={id}>{label}</Label>
        {tooltipText && <LabelTooltip tooltipText={tooltipText} />}
      </>
    )}
    <Input id={id} value={value} onChange={onChange} onBlur={onBlur} {...rest} />
    {error && <Alert status="error">{error}</Alert>}
    {hint && <Hint>{hint}</Hint>}
  </div>
);

export default FormField;
